import React, { useContext } from 'react'
import classNames from 'classnames'
import { node, string } from 'prop-types'

import Type from '../Type'
import Hide from '../Hide'
import ShrinkWrap from '../ShrinkWrap'
import { ThemeContext } from '@/component/Context/ThemeContext'

import styles from './OutlineHeading.module.scss'

const OutlineHeading = ({ heading, subHeading }) => {
  const { brandType } = useContext(ThemeContext)
  return (
    <div
      className={classNames(
        styles.OutlineHeading,
        brandType === 'Lifestyle' && styles.white
      )}
    >
      <Type
        themed
        weight="extrabold"
        className={styles.Heading}
        size={['heading5', 'display2']}
      >
        {heading}
      </Type>
      <Hide below="desktop">
        <ShrinkWrap fullWidth>
          <ShrinkWrap.Item vAlign="middle" shrink>
            <Type size={['body2', 'body5']} className={styles.SubHeading}>
              {subHeading || `Exclusive`}
            </Type>
          </ShrinkWrap.Item>
          <ShrinkWrap.Item vAlign="middle">
            <div className={styles.Divider} />
          </ShrinkWrap.Item>
        </ShrinkWrap>
      </Hide>
    </div>
  )
}

OutlineHeading.propTypes = {
  heading: node,
  subHeading: string
}

export default OutlineHeading
